import { ResourceType } from '../types/resourceType';
import api from './axios';

const baseUrl = '/rest/v1/resource-types'

export async function getResourceTypes(): Promise<PagedResult<ResourceType>> {
    const res = await api.get(baseUrl)
    return res.data as PagedResult<ResourceType>;
}